import type { TFunction } from 'i18next';
import type { RoomSummary } from '../models/Room';

export function isRoomBookingAllowed(room: Pick<RoomSummary, 'bookingAccess'>): boolean {
  return !room.bookingAccess || room.bookingAccess.bookable !== false;
}

export function roomBookingBlockedHint(t: TFunction, reason: string | null | undefined): string {
  if (reason === 'USER_GLOBALLY_BLACKLISTED') {
    return t(
      'bookingAccess.globallyBlacklistedRoom',
      'Booking is not available for your account.'
    );
  }
  if (reason === 'USER_BLACKLISTED_IN_ORGANIZATION') {
    return t(
      'bookingAccess.blockedInOrganization',
      'Booking unavailable for this organization.'
    );
  }
  return t('bookingAccess.unavailable', 'Booking is unavailable.');
}
